import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'designing-smart-theme-changer',
  styleUrls: ['../designing.component.scss'],
  templateUrl: './smartThemeChanger.component.html',
})
export class DesigningSmartThemeChangerComponent {
  @Input() step;
  @Input() totalSteps;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(public translate: TranslateService) {}

  submit() {
    this.next.emit();
  }
}
